module.exports = "<p class=\"ipsum\" data-nb=\"2\"></p>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/ipsum/sample.html
// module id = 72
// module chunks = 0